/* eslint-disable camelcase, @typescript-eslint/naming-convention -- mirrors the Rails JSON contract */
import React from 'react';
import { translate } from '@utils/i18n';
import { FlagItem } from './FlagItem';
const NS = 'features.iim_review.tech_performance_drawer';
export function RulesTrendFlagItem({ trend, thisInspectionRuleFindingsCount, buildingMedianRuleFindingsPerInspection }) {
    if (trend.custom_rule_findings_count === 0) {
        return (React.createElement(FlagItem, { icon: "fa-list-check", title: translate('rules_trend_zeroed_title', {
                namespace: NS,
                count: 0,
                defaultValue: '%{count} company rules skipped in previous inspections'
            }), description: translate('rules_trend_zeroed_desc', {
                namespace: NS,
                defaultValue: 'No company rules skipped in previous inspections'
            }) }));
    }
    return (React.createElement(FlagItem, { icon: "fa-list-check", title: translate('rules_trend_combined_title', {
            namespace: NS,
            thisCount: thisInspectionRuleFindingsCount,
            trendCount: trend.custom_rule_findings_count,
            windowCount: trend.previous_inspections_count,
            defaultValue: '%{thisCount} rules skipped here, %{trendCount} across the previous %{windowCount} inspections'
        }), description: buildingMedianRuleFindingsPerInspection != null
            ? translate('rules_trend_combined_desc', {
                namespace: NS,
                count: buildingMedianRuleFindingsPerInspection,
                defaultValue: 'Building median is %{count} per inspection'
            })
            : undefined }));
}
